module.exports = __webpack_public_path__ + "static/a1d1-2-7501b179f3091bff22258fea7090c3b0.svg";